import axios from 'axios';


export async function request(url) {
    let response;
    try {
        const res = await axios.get(url, {
            timeout: 10000
        });
        response = res.data;
        return response;
    } catch (error) {
        return {
            status: "error"
        }
    }    
}

export async function postRequest(url, body) {
    let response;
    try {
        const res = await axios.post(url, body);
        response = res.data;
        return response;
    } catch (error) {
        return {
            status: "error"
        }
    }    
}


